import badge_module_default from "./badge.module.js";
import { Badge } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/badge/Badge.tsx
const Badge$1 = ({ children, color = "primary", radius = "xxs", p, leftSection, rightSection, size = "lg", variant = "filled", dataTestId, "data-testid": testId = dataTestId ?? "badge" }) => {
	return /* @__PURE__ */ jsx(Badge, {
		"data-testid": testId,
		p,
		classNames: badge_module_default,
		color,
		size,
		radius,
		variant,
		leftSection,
		rightSection,
		children
	});
};

//#endregion
export { Badge$1 as Badge };